import makeStyles from '@mui/styles/makeStyles'

const useIndexStyles = makeStyles({
  root: {},
  bgColor: {
    backgroundColor: '#F9FAFD !important',
    height: 'calc(100vh - 64px) !important',
    marginTop: '64px !important',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '20px !important',
  },
})

export default useIndexStyles
